import React from 'react';
import EllipsisLoader from '@bonlineza/b-lib/EllipsisLoader';

const LuxityLoader = () => <EllipsisLoader />;

export default LuxityLoader;
